import styled, { css, createGlobalStyle } from "styled-components";
import { Modal } from "antd";
import { getMarginStyle, getPaddingStyle, SpacingStyle } from "core/styles/paddingMarginStyle";

export const ModalGlobalStyle = createGlobalStyle`
  body {
    overflow-y: hidden !important;

  }

  .ant-modal-mask {
    z-index: 10000;
  }

  .ant-modal-wrap {
    z-index: 10000
  }
`;

export const fullScreenStyle = css`
  top: 0px;
  margin: 0px;
  padding-bottom: unset;
  transform: unset;

  .ant-modal-content {
    border-radius: 0px;
    height: 100vh;
    width: 100vw;
  }

  .ant-modal-body {
    overflow: scroll;
    padding: unset;
  }
`;

export const Container = styled(Modal)<
  SpacingStyle & {
    atCenterScreen?: boolean;
    rightPosCloseIcon?: string;
    topPosCloseIcon?: string;
  }
>`
  font-family: Nunito-Sans;

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    padding: 40px 60px;
    position: relative;

    ${getPaddingStyle}
    ${getMarginStyle}
  }

  ${({ atCenterScreen }) =>
    atCenterScreen &&
    css`
      top: 50%;
      transform: translateY(-50%);
      padding: 0px;
    `}

  .modal-close-icon {
    position: absolute;
    cursor: pointer;

    ${({ padding, rightPosCloseIcon, topPosCloseIcon }) => {
      return css`
        right: ${rightPosCloseIcon ||
        (typeof padding === "number" ? `${padding}px` : padding) ||
        "60px"};

        top: ${topPosCloseIcon ||
        (typeof padding === "number" ? `${padding}px` : padding) ||
        "40px"};
      `;
    }}
  }
`;
